export enum MobergIconSize {
    X_SMALL = "12px",
    SMALL = "16px",
    REGULAR = "20px",
    LARGE = "24px",
    X_LARGE = "28px",
    XX_LARGE = "32px"
}